import { push } from 'connected-react-router'
import { call, put, takeLatest } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

function* saveVendorAuditAffiliateSaga({ payload }) {
    try {
        yield call(actionApiCall, {
            actionType: ActionTypeConstants.SAVE_VENDOR_AUDIT_AFFILIATE,
            data: {
                token: payload.token,
                audit_json: payload.audit_json,
            }
        });
        yield put(push(`/questionnaire/${payload.token}`));
    } catch (err) {
        yield put(push(`/questionnaire/${payload.token}`));
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.SAVE_VENDOR_AUDIT_AFFILIATE, saveVendorAuditAffiliateSaga);
}
